export default __webpack_public_path__ + "static/avatar-kayi-common-2-36b3300cebc2572ded1a7b741cc7e8f8.png";